<div class="container">
  <pdq-heading element="h6">API Key</pdq-heading>
  <div class="general">
    <div class="settings-row">
      <pdq-input
        label="API Key"
        [placeholder]="integration?.isConnected ? '••••••••••••••••' : 'Paste your Triple Whale API key'"
        [formControl]="apiKeyControl"
        [disabled]="integration?.isConnected"
        type="password"></pdq-input>
    </div>
    <p class="hint">Generate at Triple Whale: Data &gt; APIs</p>
  </div>

  <pdq-heading element="h6">Settings</pdq-heading>
  <div class="feature">
    <div class="feature-label">
      <p>Send shipping costs to Triple Whale</p>
      <p class="feature-description">
        Enable this only if you use PDQ for shipping. This will send your actual shipping costs to Triple Whale to
        improve Net Profit and POAS calculations.
      </p>
    </div>
    <pdq-slide-toggle
      [disabled]="!integration?.isConnected"
      [defaultValue]="sendShippingCosts"
      (onToggle)="sendShippingCosts = $event"></pdq-slide-toggle>
  </div>
  @if (integration?.isConnected && sendShippingCosts !== savedSendShippingCosts) {
    <p class="unsaved-hint">You have unsaved changes. Click Save to apply.</p>
  }

  <div class="actions">
    @if (integration?.isConnected) {
      <pdq-button
        label="Save"
        variant="primary"
        [loading]="savingSettings"
        [disabled]="sendShippingCosts === savedSendShippingCosts"
        (onClick)="saveSettings()"></pdq-button>
      <pdq-button label="Disconnect" variant="light" [loading]="disconnecting" (onClick)="disconnect()"></pdq-button>
    } @else {
      <pdq-button
        label="Connect"
        variant="primary"
        [disabled]="!apiKeyControl.value"
        [loading]="loading"
        (onClick)="connect()"></pdq-button>
    }
  </div>
</div>
